import {ScormUtils} from "scorm/common/ScormUtils";

export function Sco( id, scoData ) {

    const changedData = new Map();

    function setValue( dataModelId, value ) {
        scoData.setValue(dataModelId, value);
        changedData.set(dataModelId, value);
        return "true";
    }

    // revealing public api
    return {
        getId: () => id,
        getChangedData: () => changedData,

        setValue: ( dataModelId, value ) => setValue( dataModelId, value ),
        updateScore: ( newScore ) => {

            const scoreModelId = scoData.getScoreModelId(),
                score = ScormUtils.getImprovedScore( newScore, scoData.getValue( scoreModelId) );

            if (score) {
                setValue( scoreModelId, score );
            }
            return "true";
        },
        getValue: (modelId) => {
            return scoData.getValue( modelId );
        },

        getScore: () => scoData.getValue( scoData.getScoreModelId() ),
        getLessonLocation: () => scoData.getValue( scoData.getLessonLocationModelId() ),
        getLessonStatus: () => scoData.getValue( scoData.getLessonStatusModelId() ),
    };
}
